// extracted by mini-css-extract-plugin
export default {"previewBlock":"PreviewBlock_previewBlock__x1X69","icon":"PreviewBlock_icon__DI-cK","link":"PreviewBlock_link__x7wLF"};